import React, { useState } from "react";
import { Button } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import CommentIcon from "@mui/icons-material/Comment";
import { PropertiesModal } from "../properties-modal/properties-modal";

interface Props {
	data: any;
	searchAssetParts: Function;
}

export const PartsCommentsColumn = ({ data, searchAssetParts }: Props) => {
	const [openPropertiesModal, setOpenPropertiesModal] = useState(false);

	if (data) {
		return (
			<>
				<Grid2 container style={{ justifyContent: "center" }}>
					{data?.Comments && (
						<Grid2 size={{ md: 12, xs: 12 }}>
							<Button
								onClick={() => setOpenPropertiesModal(true)}
								fullWidth
								color="primary"
								style={{
									textDecoration: "none",
									fontWeight: 500,
									fontSize: "12px",
									borderRadius: "3px",
									marginRight: 8,
								}}
								title={`${(data?.Comments).substr(0, 50)}...`}
							>
								<CommentIcon />
							</Button>
						</Grid2>
					)}
				</Grid2>
				<PropertiesModal
					searchAssetParts={searchAssetParts}
					show={openPropertiesModal}
					rowSelected={data as any}
					onHide={() => setOpenPropertiesModal(false)}
				/>
			</>
		);
	} else return <></>;
};
